import store from "@/store";

const getUserFullName = (userId) => {
    const teacher = store.state?.teachers.find(t => t.id === userId)
    return teacher ? `${teacher?.lastname} ${teacher?.firstname}` : null
};

const getPupil = (pupilId) => {
    const pupil = store.state?.pupils.find(p => p.id === pupilId)
    return pupil || null
};

const getPupilFullName = (pupilId) => {
    const pupil = store.state?.pupils.find(p => p.id === pupilId)
    return pupil ? `${pupil?.lastname} ${pupil?.firstname}` : ' '
};

const getGradeFullName = (gradeId) => {
    const grade = store.state?.gradeOptions.find(g => g.id === gradeId)
    return grade ? grade.hebrewName : ' '
};

const getGradeShortName = (gradeId) => {
    const grade = store.state?.gradeOptions.find(g => g.id === gradeId)
    return grade && grade.shortName || grade  && grade.hebrewName || ' '
}

const getGrade = (gradeId) => {
    return store.state?.gradeOptions?.find(g => g.id === gradeId)
};

const getTopic = (topicId) => {
    return store.state?.subjectLesson?.find(s => s.id === topicId)
};

const getPresence = (presenceId) => {
    const presence = store.state?.presenceStatus.find(p => p.id === presenceId)
    return presence
};

const getLessonFullName = (lessonId) => {
    const lesson = store.state?.subjectLesson.find(l => l.id === lessonId)
    return lesson ? lesson.hebrewName : ' '
};

const getLessonTime = (lessonId) => {
    const lesson = store.state?.lessonTime.find(l => l.id === lessonId)
    return lesson ? lesson.hebrewName : ' '
};

const getLessonShortName = (lessonId) => {
    const lesson = store.state?.subjectLesson.find(l => l.id === lessonId)
    return lesson && lesson.shortName ||  lesson && lesson.hebrewName || ' '
};

const getTeacherFullName = (teacherId) => {
    const teacher = store.state?.teachers.find(t => t.id === teacherId)
    return teacher ? `${teacher.firstname} ${teacher.lastname}` : ' '
};

const getTeacherShortName = (teacherId) => {
    const teacher = store.state?.teachers.find(t => t.id === teacherId)
    return teacher ? `${teacher.firstname.slice(0, 1)}. ${teacher.lastname}` : ' '
};

const getTeacher = (teacherId) => {
    return {...store.state?.teachers.find(t => t.id === teacherId)}
};

export {
    getUserFullName,
    getPupilFullName,
    getGradeFullName,
    getLessonFullName,
    getTeacherFullName,
    getTeacher,
    getPresence,
    getLessonTime,
    getTeacherShortName,
    getGrade,
    getLessonShortName,
    getGradeShortName,
    getTopic,
    getPupil
};
